import { render, staticRenderFns } from "./PartnerPayment.vue?vue&type=template&id=15bd3cfa&scoped=true"
import script from "./PartnerPayment.vue?vue&type=script&lang=js"
export * from "./PartnerPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bd3cfa",
  null
  
)

export default component.exports